import React from 'react';
import OverviewChartSkeleton from "../skeletons/OverviewChartSkeleton";
import {
    Chart as ChartJS,
    TimeScale,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Tooltip,
    LineController,
    BarController,
    Filler
} from 'chart.js';
import OverviewChart from './OverviewChart';

ChartJS.register(
    TimeScale,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Tooltip,
    LineController,
    BarController,
    Filler
);
function ChartTemplate({statBalDOL,statBalLBP, chartLoading, title, dateRange}) {

    return (
        <>
            {!chartLoading ? (
                <div className="col-lg-5 col-md-12 col-sm-12">
                    <div className="row chart">
                        <div className="chartHeader">
                            <p>{title} ($)</p>
                        </div>
                        <OverviewChart chartsData={statBalDOL} dates={dateRange}/>
                    </div>
                </div>
            ) : (
                <OverviewChartSkeleton/>
            )}

            {!chartLoading ? (
                <div className="col-lg-5 col-md-12 col-sm-12">
                    <div className="row chart">
                        <div className="chartHeader">
                            <p>{title} (LBP)</p>
                        </div>
                        <OverviewChart chartsData={statBalLBP} dates={dateRange}/>
                    </div>
                </div>
            ) : (
                <OverviewChartSkeleton/>
            )}
        </>
    );
}

export default ChartTemplate;